import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

export const useDirectMessageNode = () => {
  // TODO: fix navigate - it should not be defined inside a feature
  const navigate = useNavigate();

  const handleDirectMessage = useCallback(
    async ({
      _id,
      email,
      firstName,
      lastName,
    }: {
      _id: string;
      email: string;
      firstName: string;
      lastName: string;
    }) => {
      await navigate(routes.chat.create, {
        state: { userToChat: { email, firstName, id: _id, lastName } },
      });
    },
    [navigate],
  );

  return {
    handleDirectMessage,
  };
};
